import {CrudModel} from '@ngx-ivengi/crud';
import {User} from '../../user/user.model';

export class Note extends CrudModel {
  public type: string = '';
  public icon: string;
  public message: string = '';
  public user: User;
  public createdDate: Date;

  public setType(type: string): Note {
    if(typeof type === 'string') {
      this.type = type;

      switch(this.type) {

        case 'MAILED': {
          this.icon = 'fa-envelope green';
          break;
        }

        case 'CALLED': {
          this.icon = 'fa-phone purple';
          break;
        }

        default: {
          this.icon = 'fa-comment';
          break;
        }
      }

    }
    return this;
  }

  public setMessage(message: string): Note {
    if(typeof message === 'string') {
      this.message = message;
    }
    return this;
  }

  public setUser(user: User): Note {
    if(user instanceof User) {
      this.user = user;
    }
    return this;
  }

  public setCreatedDate(dateString: string): Note {
    const date = new Date(dateString);
    if(date) {
      this.createdDate = date;
    }
    return this;
  }

  public isValid(): boolean {
    return (typeof this.type === 'string' && this.type.length > 0);
  }

  public fromResponse(response: any): void {

    const user = new User();
    this.setUser(user);

    if(response.user) {
      user.fromResponse(response.user);
    }

    this
      .setId(response.id)
      .setType(response.type)
      .setMessage(response.message)
      .setCreatedDate(response.createdDate);
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/maintenance/note/note.model.ts